import { useEffect, useState, ChangeEvent } from "react";
import "./style.css";
import {
  Button,
  Label,
  Field,
  Select,
  useId,
  Input,
  Spinner,
  Toaster,
} from "@fluentui/react-components";
import moment from "moment";
import {
  ArrowUndo16Regular,
  ArrowRedo16Regular,
  Add16Filled,
  Edit24Filled,
  Delete16Regular,
  DismissFilled,
} from "@fluentui/react-icons";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { useStyles } from "../client/Vulnerability/helper";
import TextEditor from "../../components/TextEditor";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { setDialogModalOptions } from "../../redux/modelDialogReducer";
import apiServices from "../../service";

import { formatedDate, formatedDate2, stripHtml } from "../../utils";
import ReactQuillComponent from "../../components/ReactQuillComponent";
import { setFormData, resetFormData } from "../../redux/formUpdateReducer";
import {
  useParams,
  useNavigate,
  useLocation,
  useMatch,
} from "react-router-dom";
import ContentLoader from "../../components/Loader/ContentLoader";
import { useFormik } from "formik";
import DeletePopup from "../../components/DeletePopup/Deletepopup";
import ASCButton from "../../components/Button";
import ModalDialog from "../../components/ModalDialog";
import { useToastMessage } from "../../components/ToastMessage/ToastMessage";
import FluentCompatibleDatePicker from "../../components/ControlledDatePicker/FluentCompatibleDatePicker";
interface CharacteristicProps {
  [key: string]: any;
}
function VulnerabilityFormWrapper(props: any) {
  const navigate = useNavigate();
  const { showToast, toasterId } = useToastMessage();

  const classes = useStyles();
  const selectId = useId();
  const location = useLocation();
  const [formMode, setFormMode] = useState(props.mode === "add" ? "New" : "");
  const { clientId, action, selectedItemId } = useParams();
  const [dataList, setDataList] = useState<{ [key: string]: any }[]>([]);
  const dispatch: AppDispatch = useDispatch();
  const [mode, setMode] = useState(props.mode);
  const [loading, setLoading] = useState(false);
  const [nextAction, setNextAction] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [optionLoading, setOptionLoading] = useState(false);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteApiProcessing, setDeleteApiProcessing] = useState(false);
  const isFormupdated = useSelector(
    (state: RootState) => state.formUpdated.isFormUpdated
  );
  const [past, setPast] = useState<any[]>([]);
  const [present, setPresent] = useState<{ [key: string]: any } | null>(null);
  const [future, setFuture] = useState<any[]>([]);
  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(date).format("DD-MM-YYYY");
  };

  const changeMode = (mode: string) => {
    setMode(mode);

    if (mode === "edit") {
      formikData.values = props.selectedRowItem;
    } else if (mode === "add") {
      formikData.resetForm();
    }
  };

  useEffect(() => {
    if (
      props.mode === "edit" &&
      Object.keys(props.selectedRowItem).length !== 0
    ) {
      fetchDriver();
      formikData.setValues(props.selectedRowItem);
    } else if (props.mode === "add") {
      setCharacteristic([]);
    }
  }, [props.mode, props.selectedRowItem]);

  useEffect(() => {
    fetchDriver();
  }, []);

  const formikData = useFormik({
    initialValues:
      props.mode && ["edit", "view"].includes(props.mode)
        ? props.selectedRowItem
        : {
            vulnerabilitydriver_id: "",
            vulnerabilitycharacteristic_id: "",
            note_text: "",
            ratings: "",
            vulnerability_date: null,
            vulnerability_end_date: null,
            status: "",
          },
    enableReinitialize: true,
    validate: (values) => {
      const errors: any = {};

      if (
        !values.vulnerabilitydriver_id ||
        values.vulnerabilitydriver_id === "0"
      ) {
        errors.vulnerabilitydriver_id = "Driver is required";
      }

      if (
        !values.vulnerabilitycharacteristic_id ||
        values.vulnerabilitycharacteristic_id === "0"
      ) {
        errors.vulnerabilitycharacteristic_id = "Characteristics is required";
      }

      if (!values.note_text) {
        errors.note_text = "Note is required";
      } else if (values.note_text.length > 5000) {
        errors.note_text = "Note cannot be longer than 5000 characters";
      }

      const ratingValue = Number(values.ratings);
      if (isNaN(ratingValue)) {
        errors.ratings = "Ratings must be a number";
      } else if (ratingValue > 32767) {
        errors.ratings = "Score must not exceed 32767";
      }

      const startDate = new Date(values.vulnerability_date);
      const endDate = new Date(values.vulnerability_end_date);

      if (!values.vulnerability_date || isNaN(startDate.getTime())) {
        errors.vulnerability_date = "Start date is required";
      }

      if (values.vulnerability_end_date) {
        const startDate = new Date(values.vulnerability_date);
        const endDate = new Date(values.vulnerability_end_date);

        if (!values.vulnerability_date) {
          errors.vulnerability_date = "Start date is required";
        } else if (endDate < startDate) {
          errors.vulnerability_end_date =
            "End date cannot be before start date";
        }
      }
      return errors;
    },
    onSubmit: async (values: any) => {
      if (props.mode === "add") {
        setIsLoading(true);
        try {
          let newData;
          newData = {
            vulnerability: {
              customer_id: props.activeCustomerId,
              vulnerabilitydriver_id: values.vulnerabilitydriver_id,
              ratings: values.ratings === "" ? 0 : Number(values.ratings) || 0,
              vulnerabilitycharacteristic_id:
                values.vulnerabilitycharacteristic_id,
              vulnerability_date:
                formatedDate2(values.vulnerability_date) || "",
              vulnerability_end_date:
                formatedDate2(values.vulnerability_end_date) || "",
              note_text: values.note_text,
              status: values.status || "0",
            },
          };
          apiServices.client.vulnerability
            .create(newData)
            .then((response: any) => {
              setIsLoading(false);
              if (!response.data.isError) {
                showToast(response.data.message, "", "success");
                setTimeout(() => {
                  dispatch(resetFormData());
                  getvulnerability(props.activeCustomerId);
                  if (props.module != undefined && props.module == "partner") {
                    navigate(`/clients/${clientId}/partner/vulnerability`);
                  } else {
                    navigate(`/clients/${clientId}/vulnerability`);
                  }
                }, 1000);
              } else {
                showToast("Something went wrong", "", "error");
              }
            })
            .catch((error: Error) => {
              setIsLoading(false);
              showToast("Something went wrong", "", "error");
              console.log("error");
            });
        } catch (error) {
          setIsLoading(false);
          showToast("Something went wrong", "", "error");
          console.error("Error adding folder:", error);
        }
      } else if (props.mode === "edit") {
        setIsLoading(true);
        try {
          const newData = {
            vulnerability: {
              customer_id: props.activeCustomerId,
              vulnerabilitydriver_id: values.vulnerabilitydriver_id,
              ratings: values.ratings || 0,
              vulnerabilitycharacteristic_id:
                values.vulnerabilitycharacteristic_id
                  ? values.vulnerabilitycharacteristic_id
                  : characteristic[0].vulnerabilitycharacteristic_id,
              vulnerability_date:
                formatedDate2(values.vulnerability_date) || "",
              vulnerability_end_date:
                formatedDate2(values.vulnerability_end_date) || "",
              note_text: values.note_text,
              status: values.status || "0",
            },
          };

          apiServices.client.vulnerability
            .update(props.selectedRowItem.vulnerability_id, newData)
            .then(async (response: any) => {
              setIsLoading(false);
              if (!response.data.isError) {
                showToast(response.data.message, "", "success");

                dispatch(resetFormData());
                await props.reloadData(dispatch);
                // getvulnerability(props.activeCustomerId);
                if (props.module == "partner") {
                  navigate(
                    `/clients/${clientId}/partner/vulnerability/${props.selectedRowItem.vulnerability_id}/view`
                  );
                } else {
                  navigate(
                    `/clients/${clientId}/vulnerability/${props.selectedRowItem.vulnerability_id}/view`
                  );
                }
              } else {
                setIsLoading(false);
                showToast("Something went wrong", "", "error");
              }
            })
            .catch((error: Error) => {
              setIsLoading(false);
              console.log("error", error);
            });
        } catch (error) {
          setIsLoading(false);
          console.error("Error adding document:", error);
        }
      }
    },
  });
  useEffect(() => {
    if (formikData.initialValues) {
      setPresent(formikData.initialValues);
    }
  }, [formikData.initialValues]);

  const undo = () => {
    if (past.length === 0) return;

    const previous = past[past.length - 1];
    setFuture((prev) => [present, ...prev]);
    setPast((prev) => prev.slice(0, -1));
    setPresent(previous);
    formikData.setValues(previous);
  };
  const redo = () => {
    if (future.length === 0) return;

    const next = future[0];
    setPast((prev) => [...prev, present]);
    setFuture((prev) => prev.slice(1));
    setPresent(next);
    formikData.setValues(next);
  };

  function onChangeValue(key: string, value: any) {
    handleOnChange({
      target: { name: key, value: value },
    });
    formikData.setFieldValue(key, value);
  }

  const [driver, setDriver] = useState<any>([{}]);
  const [characteristic, setCharacteristic] = useState<CharacteristicProps[]>(
    []
  );

  const fetchDriver = () => {
    setOptionLoading(true);
    apiServices.client.vulnerability
      .getDriver()
      .then((response: any) => {
        setOptionLoading(false);
        setDriver(response.data.data);
      })
      .catch((e: Error) => {
        setOptionLoading(false);
        console.log("error", e);
      });
  };
  const fetchCharacterstics = (id: string) => {
    setOptionLoading(true);
    apiServices.client.vulnerability
      .getCharacteristics(id)
      .then((response: any) => {
        setOptionLoading(false);
        const characteristics = response.data.data.data || [];
        setCharacteristic(characteristics);

        if (
          formikData?.values?.vulnerabilitydriver_id !== "" &&
          props.mode === "add"
        ) {
          formikData.setFieldValue(
            "vulnerabilitycharacteristic_id",
            characteristics[0]?.vulnerabilitycharacteristic_id || ""
          );
        } else if (
          formikData?.values?.vulnerabilitydriver_id &&
          props.mode === "edit"
        ) {
          formikData.setFieldValue(
            "vulnerabilitycharacteristic_id",
            characteristics[0]?.vulnerabilitycharacteristic_id
          );
        } else {
          formikData.setFieldValue("vulnerabilitycharacteristic_id", "");
        }
      })
      .catch((e: Error) => {
        setOptionLoading(false);
        console.log("error", e);
      });
  };

  useEffect(() => {
    setCharacteristic([]);
    if (formikData?.values?.vulnerabilitydriver_id) {
      if (formikData?.values?.vulnerabilitydriver_id !== "0") {
        fetchCharacterstics(formikData?.values?.vulnerabilitydriver_id);
      } else {
        formikData.setFieldValue("vulnerabilitycharacteristic_id", 0);
      }
    }
  }, [formikData?.values?.vulnerabilitydriver_id]);

  // const handleRowAction = (action: string, row: any) => {
  //   changeMode(action);
  //   setSelectedRowItem(row);
  // };

  const getvulnerability = (id: string) => {
    setLoading(true);
    apiServices.client.vulnerability
      .get(id)
      .then((response: any) => {
        setLoading(false);
        setDataList(response.data.data);
      })
      .catch((e: Error) => {
        setLoading(false);
        console.log("error", e);
      });
  };

  const updatePresent = (newState: any) => {
    setPast((prev) => [...prev, present]);
    setPresent(newState);
    setFuture([]);
  };
  const customHandleChange = (event: any) => {
    handleOnChange(event);
  };
  const handleOnChange = (event: any) => {
    const data = { ...formikData?.values };
    data[event.target.name] = event.target.value;
    let updated = false;
    updatePresent(data);
    if (JSON.stringify(formikData.initialValues) === JSON.stringify(data)) {
      dispatch(resetFormData());
      updated = false;
    } else {
      dispatch(setFormData());
      updated = true;
    }
    // }

    if (mode !== "add" && updated === true) {
      setFormMode("Changed");
    } else {
      setFormMode(mode === "add" ? "New" : "");
    }
  };
  const deleteData = () => {
    setDeleteApiProcessing(true);
    apiServices.client.vulnerability
      .vulnerabilityDelete(props.selectedRowItem.vulnerability_id)
      .then((response: any) => {
        setDeleteApiProcessing(false);
        if (!response.data.isError) {
          setTimeout(() => {
            showToast(response.data.message, "", "success");
            setDeletePopup(false);
            getvulnerability(props.activeCustomerId);
            if (props.module != undefined && props.module == "partner") {
              navigate(`/clients/${clientId}/partner/vulnerability`);
            } else {
              navigate(`/clients/${clientId}/vulnerability`);
            }
          }, 1000);
        } else if (response.data.isError) {
          if (
            response.data.error &&
            response.data.error &&
            Object.keys(response.data.error).length !== 0
          ) {
            const errorMessage = Array.isArray(response.data.error.message)
              ? response.data.error.message.join(", ")
              : response.data.error.message;
            showToast(errorMessage, "", "error");
          }
        } else {
          showToast("Something went wrong", "", "error");
        }
      })
      .catch((err: any) => {
        showToast(err.message, "", "error");
        setDeleteApiProcessing(false);
      });
  };

  const vulnerability = useSelector((state: RootState) => state.vulnerability);
  const partnerVulnerability: any =
    useSelector((state: RootState) => state.partnerVulnerability) || [];

  const API_PATH = `/clients/${clientId}/vulnerability`;
  const partnerAPI_PATH = `/clients/${clientId}/partner/vulnerability`;

  useEffect(() => {
    // Choose path based on module type
    const path = props.module === "partner" ? partnerAPI_PATH : API_PATH;
    const listItems =
      props.module === "partner"
        ? partnerVulnerability.listItems
        : vulnerability.listItems;

    if (
      listItems.length > 0 &&
      (!selectedItemId || selectedItemId === undefined) &&
      action !== "add"
    ) {
      navigate(
        `${path}/${listItems?.[0].vulnerability_id}/${action || "view"}`,
        {
          state: {
            selectedItem: listItems?.[0],
            section: "vulnerability",
          },
        }
      );
    } else if (listItems.length > 0 && selectedItemId && action !== "add") {
      const selectedItem = listItems.find(
        (item: any) => item.vulnerability_id === selectedItemId
      );
      const index = selectedItem
        ? listItems.findIndex(
            (item: any) => item.vulnerability_id === selectedItemId
          ) + 1
        : 1;

      navigate(`${path}/${selectedItemId}/${action || "view"}`, {
        state: {
          selectedItem: selectedItem || listItems[0],
          section: "vulnerability",
          index: index,
        },
      });
    } else {
      navigate(`${path}/${action}`);
    }
  }, [
    navigate,
    vulnerability.listItems,
    selectedItemId,
    action,
    API_PATH,
    partnerAPI_PATH,
    props.module,
  ]);
  useEffect(() => {
    if (
      props.mode === "add" &&
      !formikData?.values?.vulnerabilitydriver_id &&
      driver?.length > 0
    ) {
      formikData.setFieldValue(
        "vulnerabilitydriver_id",
        driver[0].vulnerabilitydriver_id
      );
    }
  }, [props.mode, driver, formikData.values.vulnerabilitydriver_id]);

  return loading ? (
    <ContentLoader />
  ) : (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      {(props.mode === "add" || props.mode === "edit") && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Label
                size="medium"
                weight="semibold"
                className={classes.message}
              >
                {formMode !== "" && (
                  <>
                    <span>**</span> {formMode} <span>**</span>
                  </>
                )}
              </Label>
            </div>
            <div>
              <ASCButton
                shape="rounded"
                icon={<ArrowUndo16Regular />}
                className={classes.btn_mode}
                onClick={undo}
                disabled={
                  past !== undefined && past.length === 0 ? true : false
                }
              />
              <ASCButton
                shape="rounded"
                icon={<ArrowRedo16Regular />}
                className={classes.btn_mode}
                onClick={redo}
                disabled={future.length === 0 ? true : false}
              />
            </div>
            <ASCButton
              shape="rounded"
              appearance="transparent"
              onClick={() => {
                setPast([]);
                setFuture([]);
                setPresent(formikData.initialValues);
                formikData.resetForm();
                dispatch(resetFormData());
              }}
              disabled={!isFormupdated}
              label="Reset All"
            />
          </div>

          <div className="form">
            <div className="grid_container">
              <Field label="Status">
                <Select
                  id={selectId}
                  value={formikData?.values?.status || "0"}
                  onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                    onChangeValue("status", e.target.value);
                    dispatch(setFormData());
                  }}
                  disabled={true}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </Select>
              </Field>
              <Field
                label={
                  <span>
                    Start Date<span className="required-item">*</span>
                  </span>
                }
                validationState={
                  formikData.errors.vulnerability_date ? "error" : "none"
                }
                validationMessage={`${
                  formikData?.errors?.vulnerability_date || ""
                }`}
              >
                <div className="date_picker">
                  <DatePicker
                    style={{ width: "100%" }}
                    formatDate={onFormatDate}
                    name="vulnerability_date"
                    onSelectDate={(date) => {
                      onChangeValue("vulnerability_date", date);
                      if (customHandleChange !== undefined) {
                        customHandleChange({
                          target: { name: "vulnerability_date", value: date },
                        });
                      }
                      dispatch(setFormData());
                    }}
                    value={
                      formikData?.values?.vulnerability_date
                        ? props.mode === "add"
                          ? formikData?.values?.vulnerability_date
                          : props.mode === "edit"
                          ? new Date(formikData?.values?.vulnerability_date)
                          : null
                        : null
                    }
                  />

                  {formikData?.values.vulnerability_date ? (
                    <div>
                      <DismissFilled
                        onClick={() => {
                          formikData.setFieldValue("vulnerability_date", null);
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Field>
              <Field
                label="End Date"
                validationState={
                  formikData.errors.vulnerability_end_date ? "error" : "none"
                }
                validationMessage={`${
                  formikData?.errors?.vulnerability_end_date || ""
                }`}
              >
                <div className="date_picker">
                  <DatePicker
                    style={{ width: "100%" }}
                    formatDate={onFormatDate}
                    name="vulnerability_end_date"
                    onSelectDate={(date) => {
                      onChangeValue("vulnerability_end_date", date);
                      if (customHandleChange !== undefined) {
                        customHandleChange({
                          target: {
                            name: "vulnerability_end_date",
                            value: date,
                          },
                        });
                      }
                      dispatch(setFormData());
                    }}
                    value={
                      formikData?.values?.vulnerability_end_date
                        ? props.mode === "add"
                          ? formikData?.values?.vulnerability_end_date
                          : props.mode === "edit"
                          ? new Date(formikData?.values?.vulnerability_end_date)
                          : null
                        : null
                    }
                  />
                  {formikData?.values.vulnerability_end_date ? (
                    <div>
                      <DismissFilled
                        onClick={() => {
                          formikData.setFieldValue(
                            "vulnerability_end_date",
                            null
                          );
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Field>
              <Field
                label={
                  <span>
                    Driver<span className="required-item">*</span>
                  </span>
                }
                validationState={
                  formikData.errors.vulnerabilitydriver_id ? "error" : "none"
                }
                validationMessage={`${
                  formikData?.errors?.vulnerabilitydriver_id || ""
                }`}
              >
                <Select
                  id={selectId}
                  value={formikData?.values?.vulnerabilitydriver_id}
                  onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                    onChangeValue("vulnerabilitydriver_id", e.target.value);

                    dispatch(setFormData());
                  }}
                >
                  <option value={0} disabled>
                    {"Select a Driver"}
                  </option>
                  {driver &&
                    driver.map((optn: any) => (
                      <option
                        key={optn?.vulnerabilitydriver_id}
                        value={optn.vulnerabilitydriver_id}
                        selected={
                          formikData?.values?.vulnerabilitydriver_id ===
                          optn?.vulnerabilitydriver_id
                        }
                      >
                        {optn.driver}
                      </option>
                    ))}
                </Select>
              </Field>
              <Field
                label={
                  <span>
                    Characteristics<span className="required-item">*</span>
                  </span>
                }
                validationState={
                  formikData.errors.vulnerabilitycharacteristic_id
                    ? "error"
                    : "none"
                }
                validationMessage={`${
                  formikData?.errors?.vulnerabilitycharacteristic_id || ""
                }`}
              >
                <Select
                  id={selectId}
                  onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                    onChangeValue(
                      "vulnerabilitycharacteristic_id",
                      e.target.value
                    );
                    dispatch(setFormData());
                  }}
                  value={formikData?.values?.vulnerabilitycharacteristic_id}
                >
                  {characteristic.length &&
                    characteristic.map((optn: any) => (
                      <option
                        key={optn?.vulnerabilitycharacteristic_id}
                        value={optn?.vulnerabilitycharacteristic_id}
                        selected={
                          formikData?.values?.vulnerabilitycharacteristic_id ===
                          optn?.vulnerabilitycharacteristic_id
                        }
                      >
                        {optn?.characteristics}
                      </option>
                    ))}
                </Select>
              </Field>
              <Field
                label="Score"
                validationState={formikData.errors.ratings ? "error" : "none"}
                validationMessage={`${formikData?.errors?.ratings || ""}`}
              >
                <Input
                  type="number"
                  name="ratings"
                  min="0"
                  value={formikData?.values?.ratings}
                  onChange={(ev: any) => {
                    onChangeValue("ratings", ev.target.value);
                    dispatch(setFormData());
                  }}
                />
              </Field>
              <Field
                label={
                  <span>
                    Note<span className="required-item">*</span>
                  </span>
                }
                validationState={formikData.errors.note_text ? "error" : "none"}
                validationMessage={`${formikData?.errors?.note_text || ""}`}
              >
                <div className="note_field">
                  <TextEditor
                    name="note_text"
                    inputData={formikData?.values?.note_text}
                    onChange={(text: string) => {
                      const cleanedText = stripHtml(text).trim();
                      const sanitizedText =
                        /^(<p>\s*<br>\s*<\/p>|\s*)$/i.test(text.trim()) ||
                        cleanedText === ""
                          ? ""
                          : text;
                      onChangeValue("note_text", sanitizedText);
                      dispatch(setFormData());
                    }}
                  />

                  <div>
                    {formikData?.values?.note_text?.length}/{5000}
                  </div>
                </div>
              </Field>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 4,
              margin: "10px 0",
            }}
          >
            <Button
              shape="rounded"
              type="submit"
              appearance="primary"
              className="asc-button-primary"
              onClick={() => {
                if (isFormupdated) {
                  formikData.handleSubmit();
                }
              }}
              disabled={
                !isFormupdated || Object.keys(formikData.errors).length === 0
                  ? false
                  : true
              }
              icon={isLoading ? <Spinner size="tiny" /> : null}
            >
              {isLoading ? "Processing" : "Save"}
            </Button>

            {props.tabMenuIndex &&
              props.tabMenuIndex.next !== -1 &&
              !props.isContactHistory && (
                <ASCButton
                  shape="rounded"
                  className={classes.btn_mode}
                  onClick={() => {
                    setNextAction("next");
                    isFormupdated
                      ? formikData.handleSubmit()
                      : setNextAction("next");
                  }}
                  disabled={
                    !isFormupdated ||
                    Object.keys(formikData.errors).length === 0
                      ? false
                      : true
                  }
                  label="Save & Next"
                />
              )}
            <ASCButton
              shape="rounded"
              onClick={() => {
                if (isFormupdated) {
                  dispatch(
                    setDialogModalOptions({
                      open: true,
                      content_line_1:
                        "We have detected an attempt to move away from the current page.",
                      content_line_2:
                        "This would cause all changes made to be lost",
                      cancel: {
                        onclick: () => {
                          setPast([]);
                          setFuture([]);
                          setPresent(formikData.initialValues);
                          dispatch(
                            setDialogModalOptions({
                              open: false,
                            })
                          );
                          dispatch(resetFormData());
                          changeMode("");
                          formikData.resetForm();

                          if (
                            props.module != undefined &&
                            props.module == "partner"
                          ) {
                            navigate(
                              `/clients/${clientId}/partner/vulnerability`
                            );
                          } else {
                            navigate(`/clients/${clientId}/vulnerability`);
                          }
                        },
                        label: "Leave the Page",
                      },
                      no: {
                        onclick: () => {
                          dispatch(setDialogModalOptions({ open: false }));
                        },
                        label: "Stay on Page",
                        type: "primary",
                      },
                    })
                  );
                } else {
                  setPast([]);
                  setFuture([]);
                  setPresent(formikData.initialValues);
                  formikData.resetForm();
                  const currentPath = location.pathname;
                  const newPath = currentPath
                    .replace("/edit", "/view")
                    .replace("/add", "/");
                  navigate(newPath, { replace: true });
                }
              }}
              label="Cancel"
            />
          </div>
        </div>
      )}
      {props.mode === "view" && (
        <div>
          <div className="btn-wraper-container">
            <div>
              Record {props.activeRow} of {props.dataList.length}
            </div>
            <div>
              <ASCButton
                shape="rounded"
                className="asc-button-primary"
                style={{ marginRight: 2, marginBottom: 6 }}
                appearance="primary"
                size="medium"
                icon={<Add16Filled />}
                onClick={() => {
                  if (props.module != undefined && props.module == "partner") {
                    navigate(`/clients/${clientId}/partner/vulnerability/add`);
                  } else {
                    navigate(`/clients/${clientId}/vulnerability/add`);
                  }
                }}
                label="Add New"
              />
              <ASCButton
                shape="rounded"
                style={{ marginRight: 2, marginBottom: 6 }}
                icon={<Edit24Filled />}
                size="medium"
                onClick={() => {
                  if (props.module != undefined && props.module == "partner") {
                    navigate(
                      `/clients/${clientId}/partner/vulnerability/${props.selectedRowItem.vulnerability_id}/edit`
                    );
                  } else {
                    navigate(
                      `/clients/${clientId}/vulnerability/${props.selectedRowItem.vulnerability_id}/edit`
                    );
                  }
                }}
                label="Edit"
              />
              <ASCButton
                shape="rounded"
                icon={<Delete16Regular />}
                style={{ marginRight: 2, marginBottom: 6, color: "red" }}
                size="medium"
                onClick={() => {
                  setDeletePopup(true);
                }}
                label="Delete"
              />
            </div>
          </div>
          <div className="form">
            <div className="grid_container">
              <div className="fieldWrapper">
                <Label weight="semibold" size="medium">
                  Status
                </Label>
                <Label>
                  {props.selectedRowItem?.status === "0" ||
                  props.selectedRowItem?.status === 0
                    ? "Inactive"
                    : "Active"}
                </Label>
              </div>
              <div className="fieldWrapper">
                <Label weight="semibold" size="medium">
                  Start Date
                </Label>
                <Label>
                  {formatedDate(props.selectedRowItem?.vulnerability_date)}
                </Label>
              </div>
              <div className="fieldWrapper">
                <Label weight="semibold" size="medium">
                  End Date
                </Label>
                <Label>
                  {formatedDate(props.selectedRowItem?.vulnerability_end_date)}
                </Label>
              </div>
              <div className="fieldWrapper">
                <Label weight="semibold" size="medium">
                  Driver
                </Label>
                <Label>{props.selectedRowItem?.driver}</Label>
              </div>
              <div className="fieldWrapper">
                <Label weight="semibold" size="medium">
                  Characteristics
                </Label>
                <Label>{props.selectedRowItem?.characteristics}</Label>
              </div>
              <div className="fieldWrapper">
                <Label weight="semibold" size="medium">
                  Score
                </Label>
                <Label> {props.selectedRowItem?.ratings}</Label>
              </div>
              <div className="fieldWrapper">
                <Label weight="semibold" size="medium">
                  Note
                </Label>

                <ReactQuillComponent value={props.selectedRowItem?.note_text} />
              </div>
            </div>
          </div>
        </div>
      )}

      <DeletePopup
        deletePopup={deletePopup}
        setDeletePopup={setDeletePopup}
        deleteData={deleteData}
        deleteApiProcessing={deleteApiProcessing}
      />
      <ModalDialog options={dialogModalOptions} />
    </>
  );
}

export default VulnerabilityFormWrapper;
